import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, Pagination, Controller, Thumbs } from 'swiper'
import { SCREENXSMAX } from '/js/variables/breakpoints'
import { css } from 'glamor'
import './event-program-cards.scss'

SwiperCore.use([Navigation,  Pagination]);

const EventProgramCards = ({children, heading}) => {
  const XSMaxQuery = `@media( max-width: ${SCREENXSMAX}px )`
  const prevButton = { [XSMaxQuery]: { left: 5 } }
  const nextButton = { [XSMaxQuery]: { right: 5 } }

  const slideOptions = {
    slidesPerView: children.length >= 3 ? 3 : children.length,
    spaceBetween: 0,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    renderPrevButton: () => <button className={`swiper-button-prev ${ css( prevButton ) }`}></button>,
    renderNextButton: () => <button className={`swiper-button-next ${ css( nextButton ) }`}></button>,
    rebuildOnUpdate: true,
    breakpoints: {
      990: {
        slidesPerView: 1,
        spaceBetween: 100,
      }
    }
  }
  return (
    <div className={ `event-program-cards event-program-cards--${children.length} ${children.length <= 3 ? 'hide-navigation-desktop' : ''}` }>
      <h2>{ heading ? heading : 'Upcoming Special Events' }</h2>
      <Swiper { ...slideOptions } >
        { children }
      </Swiper>
    </div>
  )
};
export default EventProgramCards;
